// extracted by css-extract-rspack-plugin
export default {"switchBody":"JgboE"};